import * as CONFIGS from "@/statics/configs.js";

const NODE17 = {
  NAME: "TS3C",
  INPUT1: {
    NAME: "NODE17_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  INPUT2: {
    NAME: "NODE17_INPUT2_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8021,
  },
  INPUT3: {
    NAME: "NODE17_INPUT3_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8022,
  },
  
  OUTPUT1: {
    NAME: "NODE17_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  OUTPUT2: {
    NAME: "NODE17_OUTPUT2_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe011,
  },
  OUTPUT3: {
    NAME: "NODE17_OUTPUT3_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe012,
  },
  
  TEMPERATURE: {
    NAME: "NODE17_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xe111,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};

NODE17.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE17.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE17.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE17.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE17.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE17.INPUT3.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.OUTPUT3.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE17.INPUT3.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE17.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
];
export default NODE17;
